import { ILabModel } from "./ILabModel";
import { ILabsActionInboxModel } from "./ILabsActionInboxModel";
import { ILabGraphsModel } from "./ILabsGraphModel";
import { ILabsInboxModel } from "./ILabsInboxModel";
import { ILabsTabModel } from "./ILabsTabModel";
import { ISideNoteModel } from "./ISideNoteModel";

type Model = "Model";
type LabsInboxModel = "LabsInboxModel";
type LabModel = "LabModel";
type LabGraphModel = "LabGraphModel";
type SideNoteModel = "SideNoteModel";
type LabsActionInboxModel = "LabsActionInboxModel";
type LabFillerIDsViewedNaviguationPosition = "LabFillerIDsViewedNaviguationPosition";
type SaveEncounterLabFillerId = "SaveEncounterLabFillerId";

interface IJILabsGlobalWrapper {
    Model: ILabsTabModel,
    LabsInboxModel: ILabsInboxModel,
    LabModel: ILabModel,
    LabGraphModel: ILabGraphsModel,
    SideNoteModel: ISideNoteModel,
    LabsActionInboxModel: ILabsActionInboxModel,
    LabFillerIDsViewedNaviguationPosition: number,
    saveEncounterLabFillerId: string
}

class DefaultProvider {
    public static Default(): IJILabsGlobalWrapper {
        var jsn: IJILabsGlobalWrapper = {
            Model: null,
            LabsInboxModel: null,
            LabModel: null,
            LabGraphModel: null,
            SideNoteModel: null,
            LabsActionInboxModel: null,
            LabFillerIDsViewedNaviguationPosition: 0,
            saveEncounterLabFillerId: ""
        };
        return jsn;
    }
}

interface ILabsGlobalWrapper {
    get(key: Model): ILabsTabModel;
    set(key: Model, value: ILabsTabModel): this;

    get(key: LabsInboxModel): ILabsInboxModel;
    set(key: LabsInboxModel, value: ILabsInboxModel): this;

    get(key: LabModel): ILabModel;
    set(key: LabModel, value: ILabModel): this;

    get(key: LabGraphModel): ILabGraphsModel;
    set(key: LabGraphModel, value: ILabGraphsModel): this;

    get(key: SideNoteModel): ISideNoteModel;
    set(key: SideNoteModel, value: ISideNoteModel): this;

    get(key: LabsActionInboxModel): ILabsActionInboxModel;
    set(key: LabsActionInboxModel, value: ILabsActionInboxModel): this;

    get(key: LabFillerIDsViewedNaviguationPosition): number;
    set(key: LabFillerIDsViewedNaviguationPosition, value: number): this;

    get(key: SaveEncounterLabFillerId): string;
    set(key: SaveEncounterLabFillerId, value: string): this;
}

export { DefaultProvider, ILabsGlobalWrapper };
